import { render, staticRenderFns } from "./permissionMultiSelect.vue?vue&type=template&id=b218ca98&scoped=true&lang=pug"
import script from "./permissionMultiSelect.vue?vue&type=script&lang=js"
export * from "./permissionMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./permissionMultiSelect.vue?vue&type=style&index=0&id=b218ca98&prod&scoped=true&lang=css"
import style1 from "./permissionMultiSelect.vue?vue&type=style&index=1&id=b218ca98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b218ca98",
  null
  
)

export default component.exports